<!-- ── Admin top bar ──────────────────────────────────────────────────────── -->
<div style="background:#0f172a;color:#f8fafc;padding:0;position:sticky;top:0;z-index:100;box-shadow:0 1px 3px rgba(0,0,0,.4);">
  <div style="display:flex;align-items:center;justify-content:space-between;height:52px;padding:0 16px;max-width:1400px;margin:0 auto;">
    <div style="display:flex;align-items:center;gap:4px;overflow-x:auto;scrollbar-width:none;-ms-overflow-style:none;flex:1;min-width:0;">
      <span style="font-size:13px;font-weight:700;letter-spacing:1px;color:#38bdf8;text-transform:uppercase;white-space:nowrap;flex-shrink:0;margin-right:8px;">TG Admin</span>
      <span style="width:1px;height:18px;background:#334155;flex-shrink:0;margin-right:4px;"></span>
      <a routerLink="/admin/scraper"
         style="font-size:13px;color:#94a3b8;text-decoration:none;padding:6px 10px;border-radius:4px;white-space:nowrap;flex-shrink:0;"
         onmouseover="this.style.color='#f8fafc'" onmouseout="this.style.color='#94a3b8'">Scraper</a>
      <a routerLink="/admin/vacantes"
         style="font-size:13px;color:#94a3b8;text-decoration:none;padding:6px 10px;border-radius:4px;white-space:nowrap;flex-shrink:0;"
         onmouseover="this.style.color='#f8fafc'" onmouseout="this.style.color='#94a3b8'">Vacantes</a>
      <a routerLink="/admin/usuarios"
         style="font-size:13px;color:#94a3b8;text-decoration:none;padding:6px 10px;border-radius:4px;white-space:nowrap;flex-shrink:0;"
         onmouseover="this.style.color='#f8fafc'" onmouseout="this.style.color='#94a3b8'">Usuarios</a>
      <a routerLink="/admin/gurumatch"
         style="font-size:13px;color:#94a3b8;text-decoration:none;padding:6px 10px;border-radius:4px;white-space:nowrap;flex-shrink:0;"
         onmouseover="this.style.color='#f8fafc'" onmouseout="this.style.color='#94a3b8'">GuruMatch</a>
      <a routerLink="/admin/suscripciones"
         style="font-size:13px;color:#94a3b8;text-decoration:none;padding:6px 10px;border-radius:4px;white-space:nowrap;flex-shrink:0;"
         onmouseover="this.style.color='#f8fafc'" onmouseout="this.style.color='#94a3b8'">Suscripciones</a>
      <a routerLink="/admin/config"
         style="font-size:13px;color:#94a3b8;text-decoration:none;padding:6px 10px;border-radius:4px;white-space:nowrap;flex-shrink:0;"
         onmouseover="this.style.color='#f8fafc'" onmouseout="this.style.color='#94a3b8'">Config</a>
      <span style="font-size:13px;font-weight:600;color:#f8fafc;padding:6px 10px;background:#1e3a5f;border-radius:4px;white-space:nowrap;flex-shrink:0;">Redes Sociales</span>
    </div>
    <div style="display:flex;align-items:center;gap:6px;flex-shrink:0;margin-left:8px;">
      <button (click)="cerrarSesion()"
              style="display:inline-flex;align-items:center;gap:5px;background:#7f1d1d;color:#fca5a5;border:none;border-radius:6px;padding:6px 12px;font-size:12px;font-weight:600;cursor:pointer;white-space:nowrap;">
        Salir
      </button>
    </div>
  </div>
</div>

<div style="max-width:1000px;margin:0 auto;padding:24px 16px;">

  <!-- ── Generar vista previa ─────────────────────────────────────────────── -->
  <div class="cfg-card">
    <div class="cfg-card__body" style="display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:12px;">
      <div>
        <p style="margin:0;font-size:15px;font-weight:700;color:#0f172a;">Publicación de copy con IA</p>
        <p style="margin:4px 0 0;font-size:12.5px;color:#64748b;">
          Genera un copy + imagen nuevos (DeepSeek + OpenAI gpt-image-1) con vacantes reales de la corrida más reciente del scraper.
          La generación toma entre 5 y 15 segundos.
        </p>
      </div>
      <button (click)="generarVistaPrevia()" [disabled]="generando"
              style="display:inline-flex;align-items:center;gap:8px;background:#0ea5e9;color:#fff;border:none;border-radius:8px;padding:10px 20px;font-size:14px;font-weight:700;cursor:pointer;white-space:nowrap;flex-shrink:0;">
        <svg *ngIf="generando" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:16px;height:16px;animation:spin 1s linear infinite;"><path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"/></svg>
        {{ generando ? 'Generando...' : 'Generar vista previa' }}
      </button>
    </div>
    <p *ngIf="generarErr" style="margin:0 16px 16px;font-size:12.5px;color:#dc2626;">{{generarErr}}</p>
  </div>

  <!-- ── Canales a considerar ─────────────────────────────────────────────── -->
  <div class="cfg-card" *ngIf="!cargandoCanales">
    <div class="cfg-card__head">
      <p style="margin:0;font-size:14px;font-weight:700;color:#0f172a;">Canales a considerar</p>
    </div>
    <div class="cfg-card__body" style="display:flex;gap:18px;flex-wrap:wrap;">
      <label *ngFor="let c of canales" style="display:flex;align-items:center;gap:6px;font-size:13px;cursor:pointer;"
             [style.opacity]="channelsReady[c] ? '1' : '0.5'">
        <input type="checkbox" [(ngModel)]="selected[c]" [disabled]="!channelsReady[c]">
        <span style="text-transform:capitalize;">{{ c }}</span>
        <span *ngIf="!channelsReady[c]" class="cfg-badge cfg-badge--warn" style="font-size:10px;">no configurado</span>
      </label>
      <p *ngIf="!channelsReady.wordpress && !channelsReady.facebook && !channelsReady.instagram && !channelsReady.linkedin"
         style="margin:0;font-size:12.5px;color:#b45309;">
        Ningún canal está habilitado/configurado todavía — ve a <a routerLink="/admin/config">Config → Redes Sociales</a>.
      </p>
    </div>
  </div>

  <!-- ── Mockups por red social (misma imagen/copy, presentación distinta) ──── -->
  <ng-container *ngIf="preview">
    <div id="preview-panel" style="display:flex;align-items:center;justify-content:space-between;margin:0 0 10px;">
      <span class="cfg-badge" [class.cfg-badge--ok]="!preview.promotionalOnly" [class.cfg-badge--warn]="preview.promotionalOnly">
        {{ preview.anguloVenta }}{{ preview.promotionalOnly ? ' · 100% promocional' : '' }}
      </span>
      <p style="margin:0;font-size:12px;color:#64748b;">
        {{ preview.createdAt | appDate:'medium' }} · origen {{ preview.origen }} · status {{ preview.status }}
      </p>
    </div>

    <p *ngIf="preview.usedFallbackRun" style="font-size:12px;color:#b45309;margin:0 0 12px;">
      ⚠ Se usaron vacantes de la corrida anterior del mismo día (la más reciente no tenía suficiente variedad).
    </p>

    <div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(320px,1fr));gap:16px;margin-bottom:20px;">

      <!-- Mockup WordPress: post de blog con título -->
      <div class="cfg-card" *ngIf="selected.wordpress && channelsReady.wordpress" style="margin-bottom:0;">
        <div class="cfg-card__head" style="background:#1e3a5f;">
          <p style="margin:0;font-size:12px;font-weight:700;color:#fff;">📝 WordPress — vista previa del post</p>
        </div>
        <div class="cfg-card__body">
          <h3 style="margin:0 0 10px;font-size:17px;color:#0f172a;">{{ preview.titulo }}</h3>
          <img *ngIf="preview.imageBase64" [src]="'data:image/jpeg;base64,' + preview.imageBase64"
               style="width:100%;border-radius:6px;margin-bottom:14px;display:block;">
          <div *ngIf="wpHtmlSafe" [innerHTML]="wpHtmlSafe" style="font-size:13px;color:#334155;line-height:1.6;"></div>
          <p *ngIf="!preview.wpContentHtml" style="white-space:pre-wrap;font-size:13px;color:#334155;line-height:1.6;margin:0 0 10px;">{{ preview.copyText }}</p>
          <div style="margin-top:14px;">
            <button (click)="publicarEn('wordpress')" [disabled]="publicando['wordpress'] || yaPublicado('wordpress')"
                    style="background:#1e3a5f;color:#fff;border:none;border-radius:8px;padding:8px 14px;font-size:12.5px;font-weight:600;cursor:pointer;">
              {{ yaPublicado('wordpress') ? '✓ Publicado' : (publicando['wordpress'] ? 'Publicando...' : 'Publicar en WordPress') }}
            </button>
            <div *ngIf="preview.wordpress" style="margin-top:8px;font-size:12px;" [style.color]="preview.wordpress.published ? '#16a34a' : '#dc2626'">
              {{ preview.wordpress.published ? 'Publicado ✓' : ('Error — ' + preview.wordpress.errorMessage) }}
              <a *ngIf="preview.wordpress.externalUrl" [href]="preview.wordpress.externalUrl" target="_blank" style="margin-left:6px;">ver publicación</a>
            </div>
          </div>
        </div>
      </div>

      <!-- Mockup Facebook: foto + caption -->
      <div class="cfg-card" *ngIf="selected.facebook && channelsReady.facebook" style="margin-bottom:0;">
        <div class="cfg-card__head" style="background:#1d4ed8;">
          <p style="margin:0;font-size:12px;font-weight:700;color:#fff;">📘 Facebook — vista previa del post</p>
        </div>
        <div class="cfg-card__body">
          <div style="display:flex;align-items:center;gap:8px;margin-bottom:8px;">
            <div style="width:32px;height:32px;border-radius:50%;background:#cbd5e1;flex-shrink:0;"></div>
            <div>
              <p style="margin:0;font-size:12.5px;font-weight:700;color:#0f172a;">TG Empleos</p>
              <p style="margin:0;font-size:10.5px;color:#94a3b8;">Ahora mismo · 🌐</p>
            </div>
          </div>
          <p style="white-space:pre-wrap;font-size:13px;color:#0f172a;line-height:1.5;margin:0 0 10px;">{{ preview.copyText }}</p>
          <img *ngIf="preview.imageBase64" [src]="'data:image/jpeg;base64,' + preview.imageBase64"
               style="width:100%;border-radius:6px;display:block;">
          <div style="margin-top:14px;">
            <button (click)="publicarEn('facebook')" [disabled]="publicando['facebook'] || yaPublicado('facebook')"
                    style="background:#1d4ed8;color:#fff;border:none;border-radius:8px;padding:8px 14px;font-size:12.5px;font-weight:600;cursor:pointer;">
              {{ yaPublicado('facebook') ? '✓ Publicado' : (publicando['facebook'] ? 'Publicando...' : 'Publicar en Facebook') }}
            </button>
            <div *ngIf="preview.facebook" style="margin-top:8px;font-size:12px;" [style.color]="preview.facebook.published ? '#16a34a' : '#dc2626'">
              {{ preview.facebook.published ? 'Publicado ✓' : ('Error — ' + preview.facebook.errorMessage) }}
              <a *ngIf="preview.facebook.externalUrl" [href]="preview.facebook.externalUrl" target="_blank" style="margin-left:6px;">ver publicación</a>
            </div>
          </div>
        </div>
      </div>

      <!-- Mockup Instagram: imagen cuadrada + caption -->
      <div class="cfg-card" *ngIf="selected.instagram && channelsReady.instagram" style="margin-bottom:0;">
        <div class="cfg-card__head" style="background:#be185d;">
          <p style="margin:0;font-size:12px;font-weight:700;color:#fff;">📸 Instagram — vista previa del post</p>
        </div>
        <div class="cfg-card__body">
          <div style="display:flex;align-items:center;gap:8px;margin-bottom:8px;">
            <div style="width:28px;height:28px;border-radius:50%;background:#cbd5e1;flex-shrink:0;"></div>
            <p style="margin:0;font-size:12.5px;font-weight:700;color:#0f172a;">tgempleos</p>
          </div>
          <img *ngIf="preview.imageBase64" [src]="'data:image/jpeg;base64,' + preview.imageBase64"
               style="width:100%;aspect-ratio:1/1;object-fit:cover;border-radius:6px;display:block;margin-bottom:10px;">
          <p style="white-space:pre-wrap;font-size:12.5px;color:#0f172a;line-height:1.5;margin:0;">
            <strong>tgempleos</strong> {{ preview.copyText }}
          </p>
          <div style="margin-top:14px;">
            <button (click)="publicarEn('instagram')" [disabled]="publicando['instagram'] || yaPublicado('instagram')"
                    style="background:#be185d;color:#fff;border:none;border-radius:8px;padding:8px 14px;font-size:12.5px;font-weight:600;cursor:pointer;">
              {{ yaPublicado('instagram') ? '✓ Publicado' : (publicando['instagram'] ? 'Publicando...' : 'Publicar en Instagram') }}
            </button>
            <div *ngIf="preview.instagram" style="margin-top:8px;font-size:12px;" [style.color]="preview.instagram.published ? '#16a34a' : '#dc2626'">
              {{ preview.instagram.published ? 'Publicado ✓' : ('Error — ' + preview.instagram.errorMessage) }}
              <a *ngIf="preview.instagram.externalUrl" [href]="preview.instagram.externalUrl" target="_blank" style="margin-left:6px;">ver publicación</a>
            </div>
          </div>
        </div>
      </div>

      <!-- Mockup LinkedIn: post profesional -->
      <div class="cfg-card" *ngIf="selected.linkedin && channelsReady.linkedin" style="margin-bottom:0;">
        <div class="cfg-card__head" style="background:#0369a1;">
          <p style="margin:0;font-size:12px;font-weight:700;color:#fff;">💼 LinkedIn — vista previa del post</p>
        </div>
        <div class="cfg-card__body">
          <div style="display:flex;align-items:center;gap:8px;margin-bottom:8px;">
            <div style="width:32px;height:32px;border-radius:6px;background:#cbd5e1;flex-shrink:0;"></div>
            <div>
              <p style="margin:0;font-size:12.5px;font-weight:700;color:#0f172a;">TG Empleos</p>
              <p style="margin:0;font-size:10.5px;color:#94a3b8;">Bolsa de trabajo tech · Ahora</p>
            </div>
          </div>
          <p style="white-space:pre-wrap;font-size:13px;color:#0f172a;line-height:1.5;margin:0 0 10px;">{{ preview.copyText }}</p>
          <img *ngIf="preview.imageBase64" [src]="'data:image/jpeg;base64,' + preview.imageBase64"
               style="width:100%;border-radius:6px;display:block;">
          <div style="margin-top:14px;">
            <button (click)="publicarEn('linkedin')" [disabled]="publicando['linkedin'] || yaPublicado('linkedin')"
                    style="background:#0369a1;color:#fff;border:none;border-radius:8px;padding:8px 14px;font-size:12.5px;font-weight:600;cursor:pointer;">
              {{ yaPublicado('linkedin') ? '✓ Publicado' : (publicando['linkedin'] ? 'Publicando...' : 'Publicar en LinkedIn') }}
            </button>
            <div *ngIf="preview.linkedin" style="margin-top:8px;font-size:12px;" [style.color]="preview.linkedin.published ? '#16a34a' : '#dc2626'">
              {{ preview.linkedin.published ? 'Publicado ✓' : ('Error — ' + preview.linkedin.errorMessage) }}
              <a *ngIf="preview.linkedin.externalUrl" [href]="preview.linkedin.externalUrl" target="_blank" style="margin-left:6px;">ver publicación</a>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div style="display:flex;align-items:center;gap:10px;margin-bottom:24px;">
      <button (click)="publicarEnSeleccionados()" [disabled]="!hayCanalSeleccionado() || !!publicando['todos']"
              style="background:#0ea5e9;color:#fff;border:none;border-radius:8px;padding:10px 18px;font-size:13px;font-weight:700;cursor:pointer;">
        {{ publicando['todos'] ? 'Publicando...' : 'Publicar en los canales marcados arriba' }}
      </button>
      <p *ngIf="publicarErr" style="margin:0;font-size:12.5px;color:#dc2626;">{{publicarErr}}</p>
    </div>
  </ng-container>

  <!-- ── Historial ─────────────────────────────────────────────────────────── -->
  <div class="cfg-card">
    <div class="cfg-card__head">
      <p style="margin:0;font-size:14px;font-weight:700;color:#0f172a;">Historial de publicaciones</p>
    </div>
    <div class="cfg-card__body">
      <p *ngIf="cargandoHistorial" style="font-size:13px;color:#64748b;">Cargando...</p>
      <table *ngIf="!cargandoHistorial && historial.length" style="width:100%;border-collapse:collapse;font-size:12.5px;">
        <thead>
          <tr style="text-align:left;border-bottom:1px solid #e2e8f0;">
            <th style="padding:8px 6px;">Fecha</th>
            <th style="padding:8px 6px;">Origen</th>
            <th style="padding:8px 6px;">Título</th>
            <th style="padding:8px 6px;">Ángulo</th>
            <th style="padding:8px 6px;">WordPress</th>
            <th style="padding:8px 6px;">Facebook</th>
            <th style="padding:8px 6px;">Instagram</th>
            <th style="padding:8px 6px;">LinkedIn</th>
            <th style="padding:8px 6px;"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let h of historial" style="border-bottom:1px solid #f1f5f9;">
            <td style="padding:8px 6px;color:#475569;">{{ h.createdAt | appDate:'short' }}</td>
            <td style="padding:8px 6px;">{{ h.origen }}</td>
            <td style="padding:8px 6px;max-width:220px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">{{ h.titulo }}</td>
            <td style="padding:8px 6px;">{{ h.anguloVenta }}</td>
            <td style="padding:8px 6px;">
              <a *ngIf="h.wordpress?.published" [href]="h.wordpress.externalUrl" target="_blank" style="color:#16a34a;">✓ ver</a>
              <span *ngIf="!h.wordpress?.published" style="color:#94a3b8;">—</span>
            </td>
            <td style="padding:8px 6px;">
              <a *ngIf="h.facebook?.published" [href]="h.facebook.externalUrl" target="_blank" style="color:#16a34a;">✓ ver</a>
              <span *ngIf="!h.facebook?.published" style="color:#94a3b8;">—</span>
            </td>
            <td style="padding:8px 6px;">
              <a *ngIf="h.instagram?.published" [href]="h.instagram.externalUrl" target="_blank" style="color:#16a34a;">✓ ver</a>
              <span *ngIf="!h.instagram?.published" style="color:#94a3b8;">—</span>
            </td>
            <td style="padding:8px 6px;">
              <a *ngIf="h.linkedin?.published" [href]="h.linkedin.externalUrl" target="_blank" style="color:#16a34a;">✓ ver</a>
              <span *ngIf="!h.linkedin?.published" style="color:#94a3b8;">—</span>
            </td>
            <td style="padding:8px 6px;">
              <button (click)="verDetalle(h.id)"
                      [style.background]="tienePendientes(h) ? '#0ea5e9' : 'transparent'"
                      [style.color]="tienePendientes(h) ? '#fff' : '#64748b'"
                      style="border:1px solid #e2e8f0;border-radius:6px;padding:3px 10px;font-size:11.5px;font-weight:600;cursor:pointer;">
                {{ tienePendientes(h) ? 'Ver y publicar' : 'Ver' }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <p *ngIf="!cargandoHistorial && !historial.length" style="font-size:13px;color:#94a3b8;">Todavía no hay publicaciones.</p>
    </div>
  </div>
</div>
